import React, { createContext, useContext, useState, useEffect } from 'react';

/**
 * TabletModeContext: auto-detects tablet vs mobile based on viewport width.
 * Reacts to resize / orientation changes so the layout adapts on the fly.
 *
 *   >= 768px  -> tablet
 *   < 768px   -> mobile
 */

const BREAKPOINT = 768;

const detectIsTablet = () => {
  if (typeof window === 'undefined') return false;
  return window.innerWidth >= BREAKPOINT;
};

const TabletModeContext = createContext({
  isTablet: false,
});

export const useTabletMode = () => useContext(TabletModeContext);

export const TabletModeProvider = ({ children }) => {
  const [isTablet, setIsTablet] = useState(detectIsTablet);

  useEffect(() => {
    const onResize = () => setIsTablet(detectIsTablet());
    window.addEventListener('resize', onResize);
    window.addEventListener('orientationchange', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
      window.removeEventListener('orientationchange', onResize);
    };
  }, []);

  useEffect(() => {
    if (typeof document !== 'undefined') {
      if (isTablet) document.body.classList.add('tablet-mode');
      else document.body.classList.remove('tablet-mode');
    }
  }, [isTablet]);

  return (
    <TabletModeContext.Provider value={{ isTablet }}>
      {children}
    </TabletModeContext.Provider>
  );
};

export default TabletModeContext;
